"use client";

import { useRouter } from "@/lib/hooks/useRouter";
import { Error } from './(main)/components/Error';

export default function ErrorPage() {
	const router = useRouter();

	return (
		<Error
			header="500 - Internal Server Error"
			description={(<>Yeah, this one is on us - sorry about that. Maybe try refreshing?</>)}
			link={{
				text: (<>
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">{/*!Font Awesome Free v7.0.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.*/}<path d="M73.4 297.4C60.9 309.9 60.9 330.2 73.4 342.7L233.4 502.7C245.9 515.2 266.2 515.2 278.7 502.7C291.2 490.2 291.2 469.9 278.7 457.4L173.3 352L544 352C561.7 352 576 337.7 576 320C576 302.3 561.7 288 544 288L173.3 288L278.7 182.6C291.2 170.1 291.2 149.8 278.7 137.3C266.2 124.8 245.9 124.8 233.4 137.3L73.4 297.3z" /></svg>
					<span>Back</span>
				</>),
				onClick: () => router.back()
			}}
			height="100vh"
		/>
	)
}